// extracted by mini-css-extract-plugin
module.exports = {"container":"text-card_container__yO5T1","header":"text-card_header__O8L3z","logo":"text-card_logo__pCZf5","text":"text-card_text__YERKA"};